import React, { useState } from 'react';
import { useCategoryContext } from '../../context/CategoryContext';

const CategoryManager = () => {
  const { categories, addCategory, updateCategory, deleteCategory } = useCategoryContext();
  const [formData, setFormData] = useState({
    name: '',
    color: '#3b82f6'
  });
  const [editMode, setEditMode] = useState(false);
  const [currentCategoryId, setCurrentCategoryId] = useState(null);
  const [error, setError] = useState('');

  const { name, color } = formData;

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async e => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Il nome della categoria è obbligatorio');
      return;
    }

    try {
      if (editMode) {
        await updateCategory(currentCategoryId, formData);
        setEditMode(false);
        setCurrentCategoryId(null);
      } else {
        await addCategory(formData);
      }
      setFormData({ name: '', color: '#3b82f6' });
    } catch (err) {
      setError(err.response?.data?.message || 'Si è verificato un errore');
    }
  };

  const onEdit = category => {
    setFormData({
      name: category.name,
      color: category.color
    });
    setEditMode(true);
    setCurrentCategoryId(category._id);
  };

  const onDelete = async id => {
    if (window.confirm('Sei sicuro di voler eliminare questa categoria?')) {
      try {
        await deleteCategory(id);
        if (currentCategoryId === id) {
          setEditMode(false);
          setCurrentCategoryId(null);
          setFormData({ name: '', color: '#3b82f6' });
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Si è verificato un errore');
      }
    }
  };

  const onCancel = () => {
    setEditMode(false);
    setCurrentCategoryId(null);
    setFormData({ name: '', color: '#3b82f6' });
  };

  return (
    <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6 mb-6">
      <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-white">Gestione Categorie</h2>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}
      
      <form onSubmit={onSubmit} className="mb-6">
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <div className="flex-grow">
            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Nome Categoria
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={onChange}
              className="w-full px-4 py-2 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
              placeholder="Inserisci il nome della categoria"
            />
          </div>
          
          <div className="w-full md:w-32">
            <label htmlFor="color" className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Colore
            </label>
            <input
              type="color"
              id="color"
              name="color"
              value={color}
              onChange={onChange}
              className="h-10 w-full cursor-pointer rounded border bg-transparent p-0 ring-gray-300 focus:ring-2 focus:ring-blue-500 dark:ring-gray-700"
            />
          </div>
        </div>
        
        <div className="flex justify-end gap-2">
          {editMode && (
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600"
            >
              Annulla
            </button>
          )}
          <button
            type="submit"
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-blue-600 dark:hover:bg-blue-700"
          >
            {editMode ? 'Aggiorna Categoria' : 'Aggiungi Categoria'}
          </button>
        </div>
      </form>
      
      <h3 className="font-semibold text-lg mb-2 text-gray-800 dark:text-white">Le tue Categorie</h3>
      
      {categories.length === 0 ? (
        <p className="text-gray-600 dark:text-gray-400">Non hai ancora creato nessuna categoria.</p>
      ) : (
        <ul className="space-y-2">
          {categories.map(category => (
            <li 
              key={category._id} 
              className="flex items-center justify-between p-3 rounded-md border border-gray-200 dark:border-gray-700"
            >
              <div className="flex items-center">
                <span 
                  className="w-4 h-4 rounded-full mr-3" 
                  style={{ backgroundColor: category.color }}
                ></span>
                <span className="text-gray-800 dark:text-gray-200">{category.name}</span>
              </div>
              
              <div className="flex gap-2">
                <button
                  onClick={() => onEdit(category)}
                  className="text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
                >
                  Modifica
                </button>
                <button
                  onClick={() => onDelete(category._id)}
                  className="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
                >
                  Elimina
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryManager;